import { useBatchReveal } from "../animations/hooks";
import { Link } from "react-router-dom";
import { getLanguage } from "../helpers/storageHelper";

function NineSeeMore(props) {
    const data = props?.data;
    const page = props?.page;
    const language = getLanguage();
    const photoURL = process.env.REACT_APP_SHANDE_PHOTO_URL;
    // Re-runs when more items are appended; already-revealed cards are left alone.
    const gridRef = useBatchReveal({ stagger: 0.1 }, [data?.length]);
    return (
        <section className="pt-3">
            <div className="container">
                <div className="row" ref={gridRef}>
                    {
                        data && data.map(item => (
                            <div className="col-md-6 col-lg-4 zoom-on-hover" data-reveal key={item?.id}>
                                <div className="item transition text-center news-image-container">
                                    <img className="mw-100 mh-100 image" src={item?.mainImageUrl} alt={item?.enTitle} />
                                </div>
                                <div className="project-card-no-image">
                                    <h3>{language == 1 ? item?.title : item?.enTitle}</h3>
                                    <h4>{language == 1 ? item?.content : item?.enContent}</h4>
                                    <Link className="btn btn-outline-primary btn-sm" to={`/${page}Details?id=${item?.id}`} state={item}>See More</Link>
                                    <div className="tags"><p>{item?.date}</p></div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </section>
    )
}
export default NineSeeMore;